import React, { createContext, useContext, ReactNode } from "react";
import {
  GenerateRequest,
  GenerateResponseOfBaseModel,
} from "../Clients/reminds";
import { useMutation } from "@tanstack/react-query";
import { useApiClientContext } from "./ApiClient.Context";

interface ContextType {
  generate: (
    base: GenerateRequest,
    onSuccess?: (data: GenerateResponseOfBaseModel) => void
  ) => void;
  isAdding: boolean;
}

const GenerateContext = createContext<ContextType | undefined>(undefined);

export const useGenerateContext = () => {
  const context = useContext(GenerateContext);
  if (!context) {
    throw new Error(
      "useGenerateContext must be used within a GenerateProvider"
    );
  }
  return context;
};

interface Props {
  children: ReactNode;
}

export const GenerateProvider: React.FC<Props> = ({ children }) => {
  const { generateClient } = useApiClientContext();

  const { mutate, isPending: isAdding } = useMutation({
    mutationFn: (base: GenerateRequest) => generateClient.generate(base),
    onSuccess: () => {},
  });

  const generate = (
    item: GenerateRequest,
    onSuccess?: (data: GenerateResponseOfBaseModel) => void
  ) => {
    mutate(item, {
      onSuccess: (data) => {
        onSuccess?.(data);
      },
    });
  };

  return (
    <GenerateContext.Provider value={{ generate, isAdding }}>
      {children}
    </GenerateContext.Provider>
  );
};
